export default __webpack_public_path__ + "static/m-team2-08b8fa133eff97648daa92e131b907dc.png";